import { memo } from 'react';

import { Spinner } from '@air/primitive-spinner';

export const SkipOnboardingLoadingOverlay = memo(() => {
  return (
    // biome-ignore lint/a11y/useSemanticElements: we're not using this in a form, so `output` is not relevant
    <div role="status" aria-label="Loading" className="fixed inset-0 z-50 flex items-center justify-center bg-grey-1">
      <Spinner className="size-10 text-teal-9" />
    </div>
  );
});

SkipOnboardingLoadingOverlay.displayName = 'SkipOnboardingLoadingOverlay';
